/* eslint-disable*/
export * from './common'
import { $t } from '@plugin/i18n'
const regexp = {
  mobile: /^(13|14|15|17|18|19)[0-9]{9}$/,
  phone: /^(\d{3}-?\d{8})|(\d{4}-?\d{7})$/,
  email: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
}

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path: string) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

export function validMobile(rule: any, mobile: string, callback: any) {
  if (!mobile || regexp.mobile.test(mobile)) {
    return callback()
  }
  callback(new Error($t('common.validMobile')))
}

export function validPhone(rule: any, phone: string, callback: any) {
  if (!phone || regexp.phone.test(phone)) {
    return callback()
  }
  callback(new Error($t('common.validPhone')))
}

export function validEmail(rule: any, email: string, callback: any) {
  if (!email || regexp.email.test(email)) {
    return callback()
  }
  callback(new Error($t('common.validEmail')))
}

export { default as formatDate } from './element-utils/date-util.js'

export function getTreeData(data: any[], id: string = 'id', pId: string = 'pId', children: any = 'children'): any[] {
  const menuOwnerMap: {[prop: string]: any[]} = {}
  data.forEach(item => {
    if (menuOwnerMap[item[pId]]) {
      menuOwnerMap[item[pId]].push(item)
    } else {
      menuOwnerMap[item[pId]] = [item]
    }
  })
  function getChildren(child: any[]) {
    return child.map(item => {
      if (menuOwnerMap[item[id]] && menuOwnerMap[item[id]].length) {
        item[children] = getChildren(menuOwnerMap[item[id]])
      }
      return item
    }).sort((a, b) => a.sort >= b.sort ? 1 : -1)
  }
  return menuOwnerMap[0]
    .map(item => {
      const child = menuOwnerMap[item[id]]
      if (child && child.length) {
        item[children] = getChildren(child)
      }
      return item
    })
}

export function typeOf(obj: any) {
  const toString = Object.prototype.toString
  const map: {[prop: string]: string} = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  }
  return map[toString.call(obj)]
}

export function deepCopy(data: any) {
  const t = typeOf(data)
  let o: any

  if (t === 'array') {
    o = []
  } else if (t === 'object') {
    o = {}
  } else {
    return data
  }

  if (t === 'array') {
    for (let i = 0; i < data.length; i++) {
      o.push(deepCopy(data[i]))
    }
  } else if (t === 'object') {
    for (const i in data) {
      o[i] = deepCopy(data[i])
    }
  }
  return o
}

export function getTableFn(dom: any, fn: any): any {
  if (!dom || !dom.$refs || !dom.$refs.table) {
    return null
  }
  if (!dom.$refs.table[fn]) {
    return getTableFn(dom.$refs.table, fn)
  }
  return dom.$refs.table[fn].bind(dom.$refs.table)
}

// 求和
export function sum(list: number[], accuracy: number) {
  if (!list.length) return 0
  const scale = Math.pow(10, accuracy)
  const scaleTotal = list.map(i => i * scale).reduce((a, b) => a + b)
  return scaleTotal/scale
}
